import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdAdd, MdEdit, MdDelete, MdSearch } from 'react-icons/md';
import axiosInstance from '../../api/axiosInstance';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch blogs from backend
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axiosInstance.get('/blog');
        setBlogs(response.data.data || []);
      } catch (err) {
        console.error('Failed to fetch blogs:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter((blog) =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      try {
        await axiosInstance.delete(`/blog/${id}`);
        // Refresh blogs after successful delete
        const response = await axiosInstance.get('/blog');
        setBlogs(response.data.data || []);
      } catch (err) {
        alert('Failed to delete blog');
        console.error('Delete error:', err);
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Blogs</h1>
        <Link
          to="/admin/blogs/create"
          className="flex items-center justify-center gap-2 bg-[#008300] text-white px-4 py-2 rounded-lg hover:bg-[#006600] transition-colors"
        >
          <MdAdd />\n          <span>Add Blog</span>
        </Link>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative">
          <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search blogs..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#008300] focus:border-transparent outline-none"
          />
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-12 text-gray-500">
          Loading blogs...
        </div>
      )}

      {/* Blog Table */}
      {!loading && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-gray-700">
                Image
              </th>
              <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-gray-700">
                Title
              </th>
              <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-gray-700 hidden sm:table-cell">
                Author
              </th>
              <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-gray-700 hidden md:table-cell">
                Date
              </th>
              <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-gray-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filteredBlogs.map((blog) => (
              <tr key={blog.id} className="hover:bg-gray-50">
                <td className="px-4 sm:px-6 py-3 sm:py-4">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded-lg"
                  />
                </td>
                <td className="px-4 sm:px-6 py-3 sm:py-4">
                  <p className="font-medium text-gray-800 text-sm sm:text-base">{blog.title}</p>
                  <p className="text-xs sm:text-sm text-gray-500 truncate max-w-[150px] sm:max-w-xs">
                    {blog.content}
                  </p>
                </td>
                <td className="px-4 sm:px-6 py-3 sm:py-4 text-gray-600 text-sm hidden sm:table-cell">{blog.author}</td>
                <td className="px-4 sm:px-6 py-3 sm:py-4 text-gray-600 text-sm hidden md:table-cell">{blog.createdAt}</td>
                <td className="px-4 sm:px-6 py-3 sm:py-4">
                  <div className="flex items-center gap-2">
                    <Link
                      to={`/admin/blogs/edit/${blog.id}`}
                      className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                    >
                      <MdEdit />
                    </Link>
                    <button
                      onClick={() => handleDelete(blog.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <MdDelete />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        {filteredBlogs.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No blogs found
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default BlogList;
